import { I18N } from "oc-I18N";
import { ZaunCircleMenuItem } from "./ZaunCircleMenuItem";

export function ZaunCircleMenuItemAnkerAusrichtung(props) {
  const agt = APP.arrangement;
  const contract = () => {
    const pfosten = agt.selectedObjects.filter((p) => p.isPfosten && p.anker != null);
    return pfosten.length > 0 && pfosten.every((p) => p.ankerAuswahlwert != null);
  };
  if (!contract()) {
    return null;
  }
  const label = agt.selectedObjects[0].ankerInnen ? I18N("Anker außen") : I18N("Anker innen");
  return (
    <ZaunCircleMenuItem
      dataButtonKey={label}
      onClick={(event) => {
        if (!contract()) {
          return null;
        }

        const pfosten = agt.selectedObjects.filter((e) => e.isPfosten);
        pfosten.forEach((p) => {
          p.anpassungDurchUser = true;
          p.ankerInnen = !p.ankerInnen;
        });
        APP.logUserAction({ action: "toggleAnkerAusrichtung" });
        APP.dirty();
      }}
    >
      {label}
    </ZaunCircleMenuItem>
  );
}
